import { render, staticRenderFns } from "./Audit-Agree.vue?vue&type=template&id=9613a968&scoped=true&"
import script from "./Audit-Agree.vue?vue&type=script&lang=js&"
export * from "./Audit-Agree.vue?vue&type=script&lang=js&"
import style0 from "../CGC.scss?vue&type=style&index=0&id=9613a968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9613a968",
  null
  
)

export default component.exports